import { getConstant } from '../utils';

export const getProtocol = getConstant('GET_GENERAL_PROTOCOL');
export const getFedPoints = getConstant('GET_FED_POINTS');
export const getAgroPoints = getConstant('GET_AGRO_POINTS');